export default "__VITE_ASSET__B9OerM1B__"